import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_INFERNO } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/hollah.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/hollah-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/hollah-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/hollah-extreme.circles.json' with { type: 'json' };

export const HOLLAH_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'hollah',
  baseTitle: "Hollah!",
  description: "Disfigure's bouncy 140 BPM drumstep. Tight syncopation, hard-tier wave challenge.",
  difficulty: 4,
  palette: PALETTE_INFERNO,
  audioSrc: '/audio/waves/hollah.mp3',
  attribution: "\"Hollah!\" by Disfigure [NCS Release] - https://ncs.io/Hollah",
  mapper: "xChorse",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    hard: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    extreme: { bpm: 145, offsetMs: 0, totalBeats: 148 },
  },
});
